import { OrganizationNode } from '@/types/Organizations';
import { Box, Card } from '@palmetto/palmetto-components';

import { InvoiceSettingsCardHeader } from './InvoiceSettingsCardHeader';

interface InvoiceSettingsCardProps {
  organization?: OrganizationNode | undefined;
  onClick?: () => void;
  cardTitle: string;
  isLoading?: boolean;
  children?: React.ReactNode;
}

export const InvoiceSettingsCard = ({
  cardTitle,
  organization,
  isLoading,
  children,
  onClick,
}: InvoiceSettingsCardProps) => {
  return (
    <Card>
      <InvoiceSettingsCardHeader organization={organization} cardTitle={cardTitle} onClick={onClick} />
      {isLoading && <Box padding="0 lg lg lg">loading...</Box>}
      {!isLoading && !organization && <Box padding="0 lg lg lg">Organization not found</Box>}
      {!isLoading && organization && children}
    </Card>
  );
};
